<script>
export default {
	name: 'Termeni si conditii',
	data: () => {
		return {};
	},
	methods: {},
};
</script>

<template>
    <div class="container mx-auto px-4 sm:py-8 sm:container sm:mx-auto">
    <div class="maintitlecont">
      <h1 class="maintitle">{{$t('terms_and_conditions')}}</h1>
    </div>
    <div class="termeni" v-if="$i18n.locale == 'ro'">
        <h3 style="font-weight: 600;">Prin achiziționarea unui bilet prin bilet.cazinoul.com sunteți de acord cu următorii termeni și condiții, pe care vă obligați să îi respectați:</h3>
        <div class="section">
            <p class="section-title">1.	Achiziționarea biletelor</p>
            <p>Biletul nu poate fi schimbat sau returnat, indiferent de motivul invocat.</p>
            <p>În cazul anulării evenimentului, contravaloarea biletului se recuperează exclusiv de la organizatorul evenimentului. Bilet.cazinoul.com va depune toate eforturile pentru a intermedia acest transfer, dar nu este responsabil pentru rambursare.</p>
            <p>Pentru biletele achiziționate de la magazinele partenere, cererile se trimit pe office@bilet.cazinoul.com (cu numărul comenzii și copie după bilete); s-ar putea să fie necesar să ridicați banii direct de la magazinul partener.</p>
            <p>Suma returnată va cuprinde doar contravaloarea biletului și va fi rambursată în maximum 30 de zile de la solicitare.</p>
            <p>Bilet.cazinoul.com nu poate fi făcut responsabil de pagube directe sau indirecte cauzate de anularea/amânarea evenimentului.</p>
            <p>Serviciile oferite de bilet.cazinoul.com constau exclusive în vânzarea biletelor. Nu are control asupra organizării evenimentului sau locației.</p>
        </div>
        <div class="section">
            <p class="section-title">2.	Utilizarea site-ului bilet.cazinoul.com</p>
            <p>În cazul suspiciunilor privind utilizarea abuzivă sau cu rea intenție a site-ului (blocare repetată a locurilor, conturi multiple, supraîncărcare intenționată), bilet.cazinoul.com își rezervă dreptul de a suspenda sau închide contul, fără obligația de a anunța utilizatorul.</p>
            <p>În cazuri grave, bilet.cazinoul.com poate sesiza autoritățile competente.</p>
        </div>
        <div class="section">
            <p class="section-title">3.	Condiții generale privind biletele</p>
            <p>Achiziționarea biletului implică acceptarea regulamentului organizatorului evenimentului, indiferent de forma în care este comunicat.</p>
            <p>Este responsabilitatea dumneavoastră să vă informați asupra regulamentului și să contactați direct organizatorul pentru clarificări.</p>
            <p>Bilet.cazinoul.com poate solicita o taxă de procesare, pe care vă obligați să o plătiți.</p>
            <p>Bilet.cazinoul.com nu este responsabilă pentru:</p>
            <p>Intrarea cu bilete falsificate;</p>
            <p>Acțiuni care nu au legătură cu procesul de vânzare;</p>
            <p>Prejudicii aduse de terți deținătorilor biletelor.</p>
            <p>Revânzarea biletelor de către terțe părți neautorizate în scop de profit este interzisă. Organizatorul și bilet.cazinoul.com își rezervă dreptul de a refuza accesul sau evacua posesorii acestor bilete.</p>
            <p>Dacă nu este specificat altfel, biletul este valabil pentru o singură persoană și o singură reprezentație.</p>
            <p>Biletul nu poate fi oferit ca premiu în concursuri fără acordul organizatorului.</p>
        </div>
        <div class="section">
            <p class="section-title">4. Acces și condiții generale</p>
            <p>Accesul se face doar cu bilet valabil, care trebuie păstrat pe toată durata vizitei.</p>
            <p>Se intră în grupuri de maximum 50 de persoane, conform indicațiilor personalului.</p>
            <p>Este interzis accesul cu: băuturi alcoolice, droguri, substanțe periculoase, sticlă, arme, obiecte contondente, aparate foto/video profesionale (fără aprobare), biciclete sau animale (cu excepția câinilor ghizi).</p>
            <p>Toți vizitatorii vor trece prin control de securitate.</p>
            <p>Accesul cu cărucioare pentru copii nu este permis în expoziții, dar acestea pot fi lăsate la recepție.</p>
        </div>
        <div class="section">
            <p class="section-title">5. Program și acces</p>
            <p>Cazinoul este deschis marți – duminică, între 10:00 – 21:00. Ultima intrare: ora 20:30.</p>
            <p>Închis luni</p>
            <p>Casa de bilete se închide cu 30 minute înainte de finalul programului.</p>
            <p>Readmisia este interzisă: dacă părăsiți locația, nu puteți reintra cu același bilet.</p>
        </div>
        <div class="section">
            <p class="section-title">6. Comportament și siguranță</p>
            <p>Nu este permisă fumatul, consumul de alimente (în afara zonelor desemnate), zgomotul excesiv, alergatul, îmbrăcămintea indecentă sau neigienică, atingerea exponatelor, ignorarea semnalelor de alarmă sau refuzul de a respecta indicațiile personalului.</p>
            <p>Persoanele în stare de ebrietate sau sub influența substanțelor psihoactive nu vor fi primite în incintă.</p>
            <p>În caz de evacuare, urmați indicațiile personalului.</p>
            <p>Accesul în zonele nepublice este interzis fără autorizare.</p>
        </div>
        <div class="section">
            <p class="section-title">7. Fotografiere și înregistrare</p>
            <p>Fotografierea este permisă fără blitz și fără lampă video. Pentru înregistrări profesionale se plătește o taxă și este necesar acordul instituției.</p>
            <p>Utilizarea materialelor în scop comercial se face doar pe bază de contract.</p>
        </div>
        <div class="section" style="border-bottom: none;">
            <p class="section-title">8. Supraveghere și securitate</p>
            <p>Cazinoul este monitorizat video pentru siguranța vizitatorilor și protecția patrimoniului.</p>
            <p>Personalul este identificabil și are autoritatea de a cere respectarea regulamentului și, dacă este cazul, de a evacua vizitatori.</p>
            <p>Distrugerea bunurilor culturale constituie infracțiune.</p>
        </div>
    </div>

    <div class="termeni" v-else>
        <h3 style="font-weight: 600;">By purchasing a ticket through bilet.cazinoul.com, you agree to the following terms and conditions, which you are obligated to comply with:</h3>
        <div class="section">
            <p class="section-title">1. Ticket Purchase</p>
            <p>Tickets cannot be exchanged or refunded, regardless of the reason provided.</p>
            <p>In the event of cancellation, ticket refunds are handled exclusively by the event organizer. Bilet.cazinoul.com will make every effort to facilitate the process, but it is not responsible for the reimbursement.</p>
            <p>For tickets purchased from partner stores, requests must be sent to office@muzeul.ro (including the order number and a copy of the tickets); you may be required to collect the refund in person from the same store.</p>
            <p>The amount refunded will cover only the ticket’s face value and will be processed within 30 days of the request.</p>
            <p>Bilet.cazinoul.com cannot be held liable for direct or indirect damages caused by the cancellation or postponement of the event.</p>
            <p>The services provided by bilet.cazinoul.com consist solely of ticket sales. It has no control over the event or the venue.</p>
        </div>
        <div class="section">
            <p class="section-title">2. Use of the bilet.cazinoul.com Website</p>
            <p>In cases of suspected abusive or malicious use of the site (e.g., repeatedly blocking seats without completing orders, creating multiple accounts, intentionally overloading the site), bilet.cazinoul.com reserves the right to suspend or permanently close user accounts without prior notice.</p>
            <p>In serious cases, bilet.cazinoul.com may notify the appropriate authorities.</p>
        </div>
        <div class="section">
            <p class="section-title">3. General Ticket Conditions</p>
            <p>Purchasing a ticket implies acceptance of the event organizer’s rules, regardless of how they are communicated.</p>
            <p>It is your responsibility to inform yourself of these rules and contact the organizer directly for clarification.</p>
            <p>Bilet.cazinoul.com may apply a processing fee, which you agree to pay.</p>
            <p>Bilet.cazinoul.com is not responsible for:</p>
            <p>Entry with counterfeit tickets;</p>
            <p>Actions unrelated to the ticket sale process;</p>
            <p>Damages caused by third parties to ticket holders.</p>
            <p>Unauthorized resale of tickets for profit by third parties is prohibited. The organizer and bilet.cazinoul.com reserve the right to deny entry or remove holders of such tickets.</p>
            <p>Unless otherwise specified, tickets are valid for one person and one performance.</p>
            <p>Tickets cannot be used as prizes in contests without the organizer’s prior approval.</p>
        </div>
        <div class="section">
            <p class="section-title">4. Entry and General Conditions</p>
            <p>Entry is only permitted with a valid ticket, which must be kept for the duration of the visit.</p>
            <p>Access is allowed in groups of up to 50 people, following staff instructions.</p>
            <p>It is forbidden to enter with: alcoholic beverages, drugs, dangerous substances, glass, weapons, blunt objects, professional photo/video equipment (without approval), bicycles, or animals (except trained guide dogs).</p>
            <p>All visitors must pass through security screening.</p>
            <p>Baby strollers are not permitted inside exhibitions but may be left at the reception.</p>
        </div>
        <div class="section">
            <p class="section-title">5. Opening Hours and Access</p>
            <p>The casino is open Wednesday to Sunday, from 10:00 AM to 6:00 PM.</p>
            <p>Last entry: 5:30 PM.</p>
            <p>Closed on Mondays, Tuesdays, and legal holidays.</p>
            <p>The ticket office closes 15 minutes before closing time.</p>
            <p>Re-entry is prohibited: if you leave the venue, you may not re-enter with the same ticket.</p>
        </div>
        <div class="section">
            <p class="section-title">6. Behavior and Safety</p>
            <p>Smoking, eating (except in designated areas), loud noises, running, indecent or unhygienic clothing, touching exhibits, ignoring alarms, or failing to follow staff instructions are not permitted.</p>
            <p>Persons under the influence of alcohol or psychoactive substances will not be admitted.</p>
            <p>In the event of evacuation, follow staff guidance.</p>
            <p>Unauthorized access to non-public areas is forbidden.</p>
        </div>
        <div class="section">
            <p class="section-title">7. Photography and Recording</p>
            <p>Photography is allowed without flash or video lamps. For professional recordings, a fee must be paid, and prior approval is required.</p>
            <p>Commercial use of images and recordings is only permitted under contract.</p>
        </div>
        <div class="section" style="border-bottom: none;">
            <p class="section-title">8. Surveillance and Security</p>
            <p>The Casino is monitored via CCTV for visitor safety and heritage protection.</p>
            <p>Staff members are identifiable and have the authority to enforce rules and, if necessary, remove visitors.</p>
            <p>Damaging cultural property constitutes a criminal offense.</p>
        </div>
    </div>
    </div>
</template>

<style scoped>
.termeni .section-title {
    font-weight: 600;
    margin-bottom: 10px;

}
.termeni .section {
    padding: 15px 0;
    border-bottom: 1px solid #dddcdc;
}

.termeni p:last-child {
    border: none;
}
</style>
